import { capitalize } from "lodash-es";
import { FieldErrors } from "react-hook-form";

import { ErrorHint } from "src/base-components/ErrorHint";
import { Label } from "src/base-components/Label";
import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";
import { CaseTemplateFormFieldsInner } from "src/clients/case-management";

type ActionFormFieldGroupProps = {
  field: CaseTemplateFormFieldsInner;
  errors?: FieldErrors;
  children: React.ReactNode;
};

export const ActionFormFieldGroup: React.FC<ActionFormFieldGroupProps> = ({
  field,
  errors,
  children,
}) => (
  <>
    <Label mb={field.description ? "mb-0" : "mb-2"} required={field.required}>
      {capitalize(field.display_name)}
    </Label>
    {field.description && (
      <div className="mb-2">
        <MarkdownRenderer content={field.description} variant="muted" />
      </div>
    )}
    {children}
    {errors?.[field.key]?.message != null && (
      <ErrorHint>{String(errors[field.key]?.message)}</ErrorHint>
    )}
  </>
);
